import { createElementBlock as o, openBlock as l, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return l(), o("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.188 1A8.19 8.19 0 0 0 1 9.188V10a1 1 0 1 0 2 0v-.812A6.19 6.19 0 0 1 9.188 3h5.624A6.187 6.187 0 0 1 21 9.188v.758a1 1 0 1 0 2 0v-.758A8.19 8.19 0 0 0 14.813 1zM3 14a1 1 0 1 0-2 0v.813A8.19 8.19 0 0 0 9.188 23h5.624A8.19 8.19 0 0 0 23 14.813V14a1 1 0 1 0-2 0v.813A6.187 6.187 0 0 1 14.813 21H9.186A6.187 6.187 0 0 1 3 14.813zm8-2.755V9h1.632c.717 0 1.085.248 1.28.683.136.303.096.666 0 .878-.185.414-.655.684-1.28.684zm1.632 2H11V16a1 1 0 1 1-2 0V8.813C9 7.813 9.811 7 10.813 7h1.819c1.28 0 2.504.526 3.105 1.864.41.913.286 1.88 0 2.517-.61 1.36-1.976 1.864-3.105 1.864",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
//# sourceMappingURL=ic_parkspot-DHzjRbRT.js.map
